import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import PageMenu from '../components/pagemenu';
import ErrorBoundary from '../components/ErrorBoundary';
import WheelLibrary from '../components/wheels/wheellibrary';
import './wheels.css';

function Wheels() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) setIsAuthenticated(true);
  }, []);

  return (
    <div className="App">
      <Header isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
      {isAuthenticated ? (
        <ErrorBoundary>
          <div className="wheels-content">
            <WheelLibrary />
          </div>
        </ErrorBoundary>
      ) : (
        <div>Please log in to view content</div>
      )}
      <PageMenu className="bottom-nav" />
    </div>
  );
}

export default Wheels;
